(function () {
  'use strict';

  if (typeof window.CookieConsent === 'undefined') return;

  // Dynamically inject Microsoft Clarity if not already loaded.
  // Idempotent — safe to call multiple times.
  function loadClarity() {
    if (window.clarity && window.clarity.q !== undefined) return;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'x7ip2uv1n4');
  }

  function syncGtag() {
    var analytics = window.CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied';
    var ads       = window.CookieConsent.acceptedCategory('ads')       ? 'granted' : 'denied';
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage:  analytics,
        ad_storage:         ads,
        ad_user_data:       ads,
        ad_personalization: ads
      });
    }
    // If consent just flipped to granted and Clarity wasn't loaded at page-load
    // (e.g. user had GPC enabled or previously denied), dynamically inject it now.
    if (analytics === 'granted') {
      loadClarity();
    }
    if (typeof window.clarity === 'function') {
      window.clarity('consent', analytics === 'granted');
    }
  }

  window.CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: 'bar inline',
        position: 'bottom',
        equalWeightButtons: true,
        flipButtons: false
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false
      }
    },
    categories: {
      necessary: { enabled: true, readOnly: true },
      analytics: {
        autoClear: { cookies: [
          { name: /^_ga/ },
          { name: '_gid' },
          { name: /^_gat/ },
          { name: '_clck' },
          { name: '_clsk' }
        ]}
      },
      ads: {
        autoClear: { cookies: [
          { name: /^_gcl/ },
          { name: '_fbp' },
          { name: /^_fbc/ }
        ]}
      }
    },
    onFirstConsent: function () { syncGtag(); },
    onChange:       function () { syncGtag(); },
    onConsent: function () {
      if (navigator.globalPrivacyControl === true) {
        window.CookieConsent.acceptCategory(['necessary']);
      }
      syncGtag();
    },
    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'Cookie Notice',
            description: 'This site uses cookies — some to make the site work, others to understand how visitors find us and to show our ads. See our <a href="/policies/privacy-policy">Privacy Policy</a>.',
            acceptAllBtn: 'OK',
            acceptNecessaryBtn: 'Reject',
            showPreferencesBtn: 'Manage preferences'
          },
          preferencesModal: {
            title: 'Cookie Preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Save my choices',
            closeIconLabel: 'Close',
            sections: [
              {
                title: 'About these cookies',
                description: 'You can choose which cookies you allow. Necessary cookies make the site work and can’t be turned off. You can change your choices any time using the Manage Cookie Preferences link in the footer.'
              },
              {
                title: 'Necessary cookies',
                description: 'These make the site work — page navigation, secure form submission, and remembering your choices. They can’t be switched off.',
                linkedCategory: 'necessary'
              },
              {
                title: 'Analytics cookies',
                description: 'These help us see how visitors find the site so we can make it better. They do not identify you personally.',
                linkedCategory: 'analytics'
              },
              {
                title: 'Advertising cookies',
                description: 'These help us measure our ads and show ads to people who have visited this site.',
                linkedCategory: 'ads'
              }
            ]
          }
        }
      }
    }
  });

  if (navigator.globalPrivacyControl === true && !window.CookieConsent.validConsent()) {
    window.CookieConsent.acceptCategory(['necessary']);
  }
})();
